// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"numbers-6"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15.5 5H9C8.44772 5 8 5.44772 8 6V12M8 12V18C8 18.5523 8.44772 19 9 19H15C15.5523 19 16 18.5523 16 18V13C16 12.4477 15.5523 12 15 12H8Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Numbers6Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'numbers-6',
    ref,
    icon: element,
  },
));

Numbers6Icon.displayName = 'Numbers6Icon';

export default Numbers6Icon;
